var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3774 31.4102C37.0438 30.0664 33.8137 28.1054 32.2466 27.3151C30.2058 26.2871 30.0378 26.2031 28.4337 27.3949C27.3637 28.1902 26.6524 28.9007 25.4002 28.6336C24.148 28.3666 21.4269 26.8607 19.0442 24.4856C16.6616 22.1106 15.0684 19.3105 14.8005 18.0625C14.5326 16.8145 15.2549 16.1116 16.0426 15.0391C17.1529 13.5274 17.0689 13.2754 16.1199 11.2346C15.38 9.64728 13.3618 6.44747 12.0131 5.12052C10.5702 3.69531 10.5702 3.94726 9.6405 4.33359C8.88358 4.65198 8.15743 5.03909 7.47118 5.49005C6.12743 6.38281 5.38165 7.12439 4.86011 8.23886C4.33857 9.35333 4.10425 11.9661 6.79763 16.859C9.49101 21.7519 11.3807 24.2538 15.2918 28.1541C19.203 32.0543 22.2104 34.1514 26.607 36.6172C32.0459 39.6633 34.132 39.0695 35.2499 38.5488C36.3677 38.0281 37.1126 37.2891 38.0071 35.9453C38.4592 35.2602 38.8471 34.5349 39.166 33.7785C39.5532 32.8522 39.8052 32.8522 38.3774 31.4102Z",
    stroke: "white",
    strokeWidth: 2.6875,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonCallOutline);
export default __webpack_public_path__ + "static/media/ion_call-outline.c1e4d15a903079e317a0e51e3b546502.svg";
export { ForwardRef as ReactComponent };